<template>
  <div>
    <!-- Botão flutuante -->
    <b-button
      variant="primary"
      class="chat-flutuante shadow-lg d-flex align-items-center justify-content-center"
      @click="visivel = !visivel"
    >
      <feather-icon
        icon="MessageCircle"
        size="20"
      />
    </b-button>

    <!-- Janela do chat -->
    <ChatJanela
      v-if="visivel"
      @fechar="visivel = false"
    />
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import { FeatherIcon } from 'vue-feather-icons'
import ChatJanela from './ChatJanela.vue'
import socket from '../../../functions/services/socket.js'
import { getUserData } from '../../../auth/utils'

export default {
  components: {
    ChatJanela,
    BButton,
    FeatherIcon,
  },
  data() {
    return {
      visivel: false,
    }
  },
  computed: {
    async usuarioLogado() {
      const user = await getUserData()
      console.log('aqui: ', user.id)
      // Ajuste aqui conforme sua store ou auth global
      return user.id || { id: 1, nome: 'Romário' }
    },
  },
  mounted() {
    if (this.usuarioLogado && this.usuarioLogado.id) {
      socket.emit('chat_interno:join', { userId: this.usuarioLogado.id })
      console.log('✅ Entrou no chat interno como:', this.usuarioLogado.id)
    }

    socket.on('chat_interno:nova_mensagem', payload => {
      console.log('📩 Nova mensagem recebida:', payload)
    })
  },
}
</script>

  <style scoped>
  .chat-flutuante {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    z-index: 99999;
    padding: 0;
    transition: all 0.2s ease-in-out;
  }

  .chat-flutuante:hover {
    transform: scale(1.05);
    box-shadow: 0 0 0 4px rgba(115, 103, 240, 0.2);
  }
  </style>
